<template>
  <div class="help-container container-wrap">
    <easyads-head-top>
      <el-link>
        <router-link to="/">首页</router-link>
      </el-link>
      <el-divider direction="vertical"></el-divider>
      <el-link>
        <router-link to="/tools">聚合策略生成工具</router-link>
      </el-link>
      <el-divider direction="vertical"></el-divider>
    </easyads-head-top>
    <div class="content">
      <div class="main-container markdown-container">
        <div v-html="html" class="main"></div>
      </div>
    </div>
  </div>
</template>

<script>
import showdown from 'showdown'
import readMe  from '../../assets/easy_tools.md';
export default {
  data () {
    return {
      md: readMe,
      html: ''
    }
  },

  mounted () {
    let converter = new showdown.Converter()
    let text = this.md.toString()
    this.html = converter.makeHtml(text)
  },

  components: {
    showdown
  }
}
</script>

<style lang="scss" scoped>
.help-container {
  
}
</style>



// WEBPACK FOOTER //
// src/views/help/index.vue